// Screen `workflows` (plan §9.33) — owner: workflow-canvas. Tabs, search, filters and sort live in
// the URL, so they survive reloads and links. The list page (and with it React Flow, dagre and the
// start sheet) loads with the route, not with the app's first paint (plan §10.2).
import { createFileRoute } from '@tanstack/react-router';
import { WorkflowsListPage } from '../../../features/workflows/WorkflowsListPage';
import { WorkflowsSearchSchema } from '../../../features/workflows/search-schema';

export const Route = createFileRoute('/_app/automations/')({
  validateSearch: WorkflowsSearchSchema,
  component: WorkflowsRoute,
});

function WorkflowsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <WorkflowsListPage
      search={search}
      onSearch={(next, opts) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }), replace: opts?.replace ?? true })
      }
    />
  );
}
